import React from "react";
import Select, { components } from "react-select";
import { styled } from "@mui/material/styles";
const StyledSelect = styled(Select)(({ theme }) => ({
  "& .css-13cymwt-control , & .css-t3ipsp-control": {
    height: "54px",
    width: "100%",
    border: "2px solid #E8E8E8",
    color: "rgba(11, 11, 11, 0.5)",
    borderRadius: "10px",
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgba(11, 11, 11, 0.5)",
    textTransform: "capitalize",
    fontFamily: theme.typography.fontFamily,
  },
  "& .css-1u9des2-indicatorSeparator": {
    display: "none",
  },
  "&  .css-1p3m7a8-multiValue": {
    borderRadius: "40px",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    background: "rgba(11, 11, 11, 0.15)",
    padding: "0px 5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  ".css-12a83d4-MultiValueRemove": {
    background: "#232323",
    color: "#fff",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
  },
}));

const ComponentsOptionMain = styled("div")(({ theme }) => ({
  ".checkbox-input": {
    /* Hide the default checkbox */
    display: "none",
  },
  ".checkbox-label": {
    /* Style the checkbox appearance */
    display: "inline-block",
    position: "relative",
    paddingLeft: "25px" /* Adjust the padding as needed */,
    cursor: "pointer",
  },
  ".checkbox-label:before": {
    /* Create the checkbox shape */
    content: '""',
    display: "inline-block",
    width: "18px" /* Adjust the size as needed */,
    height: "18px" /* Adjust the size as needed */,
    position: "absolute",
    left: 0,
    top: "2px",
    border: "1px solid #8E939B" /* Adjust the border color as needed */,
    borderRadius: "0px" /* Adjust the border radius as needed */,
    backgroundColor: "#fff" /* Adjust the background color as needed */,
  },
  ".checkbox-input:checked + .checkbox-label:before": {
    /* Style the checkbox when checked */
    backgroundColor: "#007bff" /* Adjust the background color as needed */,
    borderColor: "#007bff" /* Adjust the border color as needed */,
  },
  ".checkbox-label:after": {
    /* Create the checkmark shape */
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "5px" /* Adjust the size as needed */,
    height: "10px" /* Adjust the size as needed */,
    border: "solid #fff" /* Adjust the border color as needed */,
    borderWidth: "0 2px 2px 0" /* Adjust the border width as needed */,
    transform: "rotate(45deg)",
    opacity: 0,
  },
  ".checkbox-input:checked + .checkbox-label:after": {
    /* Display the checkmark when checkbox is checked */
    opacity: 1,
  },
}));

const customStyles = {
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: state.isDisabled ? "none" : "none",
  }),
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? "1px solid #E8E8E8" : "1px solid #E8E8E8",
    color: "rgba(11, 11, 11, 0.5)",
    borderRadius: "10px",
    boxShadow: state.isFocused ? "0 0 4px rgba(255, 255, 255, 0.5)" : "none",
    height: "54px",
    paddingTop: "0px",
    fontSize: "14px",
    fontWeight: 400,
    padding: "0 10px",
    fontFamily: "Open Sans, sans-serif",
    marginBottom: "20px",
    overflow: "auto",
    maxHeight: 50,
    "&:hover": {
      border: "1px solid #0B0B0B",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    boxShadow: "0 0 4px rgba(255, 255, 255, 0.5)",
    borderRadius: "5px",
    marginTop: "0px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#F4F4F4" : "#fff",
    color: state.isSelected ? "#0B0B0B" : "#8E939B",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
    "&:hover": {
      backgroundColor: "#E3E3E3",
      color: "#0B0B0B",
    },
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "gray",
    fontFamily: "Open Sans, sans-serif",
    fontSize: "14px",
    fontWeight: 400,
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    transform: state.menuIsOpen ? "rotate(180deg)" : null,
  }),
};

const SelectPermissions = ({
  selectedOption,
  options,
  handleChange,
  placeholder,
  isMulti = true,
}) => {
  // Custom Checkbox component
  const CheckboxOption = ({ children, ...props }) => (
    <ComponentsOptionMain>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          className="checkbox-input"
        />
        <span className="checkbox-label">{children}</span>
      </components.Option>
    </ComponentsOptionMain>
  );

  return (
    <>
      <StyledSelect
        onChange={handleChange}
        options={options}
        value={selectedOption}
        placeholder={placeholder || "Select permissions"}
        isMulti={isMulti}
        // menuIsOpen={true}
        styles={customStyles}
        noOptionsMessage={() => (
          <span style={{ color: "#000" }}>No Data Found</span>
        )}
        components={{ Option: CheckboxOption }}
      />
    </>
  );
};

export default SelectPermissions;
